<template>
  <div class="sub-menu-item__container" >
    <!-- <v-icon :name="icon" class="icon"/> -->
    <router-link class="title" :to="path">{{ title }}</router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'plus'
    },
    path: {
      type: String,
      default: 'dashboard'
    }
  }
}
</script>

<style lang="scss" >
  .sub-menu-item__container {
    height: 100%;
    // border: solid 1px lightgray;
    // border-radius: 5px;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    padding: 0 10px;
    color: gray;
    

    &:hover{
      background-color: lightblue;
      color: white;
      cursor: pointer;
    }

    &.active {
      border-bottom: solid 5px lightblue;
      color: black;
    }
  }

  .icon {
    width: auto;
  }

  .title {
    font-size: 9pt;
    text-transform: uppercase;
    font-weight: bold;
    white-space: nowrap;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;;
    color: black;
  }
</style>